export default "__VITE_ASSET__BnVN1qas__"